export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_LOADING = "SET_LOADING";
export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";
export const SET_PERMISSION = "SET_PERMISSION";
